import { AbstractControl, ValidationErrors } from "@angular/forms";

export const PHONE_REGEXP =
    /^((\+|00)(\s|\s?-\s?)?)[0-9]{1,3}\s?((\s|\s?-\s?)?(\(0\)[-\s]?)?|0)[1-9]((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])\s?[0-9]\s?[0-9](\s|\s?-\s?)?[0-9]\s?[0-9]\s?[0-9](\s?[0-9])?$/;

export function phoneValidator(
    control: AbstractControl
): ValidationErrors | null {
    const value = control.value?.trim();
    if (value == null || value.length === 0) {
        return null;
    }
    return PHONE_REGEXP.test(value) ? null : { phone: true };
}
